import { FC } from 'react'
import CustomSortBy from '../CustomSortBy'
import s from './AlgoliaSortingSelector.module.css'

interface props {
  indexName: string
  defaultIndex: string
}

const AlgoliaSortingSelector: FC<props> = ({ indexName, defaultIndex }) => {
  return (
    <>
      <div className={s.algolia_sorting_selector}>
        <CustomSortBy
          defaultRefinement={defaultIndex ?? `${indexName}_published_at_desc`}
          items={[
            {
              value: `${indexName}_published_at_desc`,
              label: 'New Arrivals',
            },
            {
              value: `${indexName}_recently_ordered_count_desc`,
              label: 'Popularity',
            },
            {
              value: `${indexName}_price_asc`,
              label: 'Price Low to High',
            },
            {
              value: `${indexName}_price_desc`,
              label: 'Price High to Low',
            },
            {
              value: `${indexName}_price_ratio_desc`,
              label: 'Sale',
            },
          ]}
        />
      </div>
    </>
  )
}

export default AlgoliaSortingSelector
